
$(document).ready(function() {
  $('.cstm_prd_var img').click(function() {
    $(this).parent().find('img').removeClass('active');
    $(this).addClass('active');
    var clickedImgSrc = $(this).attr('src');
    $(this).parent().parent().find('.card__media .media img').attr('srcset', clickedImgSrc);
    $(this).parent().parent().find('.card__media .media img').attr('src', clickedImgSrc);
  });
});

/* dcw-table-scroll auto-wrap（2026-07-22）: 説明文内のtableに横スクロールラッパーを自動付与。
   祖先に overflow-x:auto/scroll が既にある場合（手貼りラッパーやux_sizeアコーディオン）は何もしない */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__description table, .product__accordion .accordion__content table').forEach(function (t) {
    var p = t.parentElement;
    while (p && p !== document.body) {
      var ox = getComputedStyle(p).overflowX;
      if (ox === 'auto' || ox === 'scroll') return;
      p = p.parentElement;
    }
    var w = document.createElement('div');
    w.className = 'dcw-table-scroll';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });
});
